/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';
import FluidTextInputSkeleton from '../FluidTextInput/FluidTextInput.Skeleton.js';
import FluidSelectSkeleton from '../FluidSelect/FluidSelect.Skeleton.js';

var _FluidTextInputSkelet, _FluidSelectSkeleton, _FluidSelectSkeleton2;

const FluidTimePickerSkeleton = _ref => {
  let {
    className,
    isOnlyTwo,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const wrapperClasses = cx(className, `${prefix}--time-picker--fluid--skeleton`, {
    [`${prefix}--time-picker--equal-width`]: isOnlyTwo
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: wrapperClasses
  }, rest), _FluidTextInputSkelet || (_FluidTextInputSkelet = /*#__PURE__*/React__default.createElement(FluidTextInputSkeleton, null)), _FluidSelectSkeleton || (_FluidSelectSkeleton = /*#__PURE__*/React__default.createElement(FluidSelectSkeleton, null)), !isOnlyTwo ? _FluidSelectSkeleton2 || (_FluidSelectSkeleton2 = /*#__PURE__*/React__default.createElement(FluidSelectSkeleton, null)) : null);
};

FluidTimePickerSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,

  /**
   * Specify if there are only two TimePicker elements
   */
  isOnlyTwo: PropTypes.bool
};
var FluidTimePickerSkeleton$1 = FluidTimePickerSkeleton;

export { FluidTimePickerSkeleton$1 as default };
